export default new (class LocationController {
    toLocation(data = null) {
        if (!data) {
            data = {};
        }
        return {
            longitude: isNaN(data.longitude) ? 0 : +((+(data.longitude + "")).toFixed(6)),
            latitude: isNaN(data.latitude) ? 0 : +((+(data.latitude + "")).toFixed(6)),
        };
    }

    toLatLng(location) {
        try {
            return {
                lng: parseFloat(location.longitude + ""),
                lat: parseFloat(location.latitude + ""),
            };
        } catch (e) {
            return {
                lng: 0,
                lat: 0,
            };
        }
    }

    toArrayReverse(data = null) {
        let point = this.toLocation(data);

        return [point.latitude, point.longitude];
    }

    distance(p1, p2) {
        function rad(x) {
            return (x * Math.PI) / 180;
        }

        let R = 6378137; // Earth’s mean radius in meter
        let dLat = rad(p2.latitude - p1.latitude);
        let dLong = rad(p2.longitude - p1.longitude);
        let a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(rad(p1.latitude)) *
            Math.cos(rad(p2.latitude)) *
            Math.sin(dLong / 2) *
            Math.sin(dLong / 2);
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c; // returns the distance in meter
    }

    toPolygon(zone) {
        return zone.points.map((point) => this.toLatLng(point));
    }

    arrayLocationToArrayLatLang(arr) {
        if (Array.isArray(arr)) {
            return arr.map((item) => this.toLatLng(item));
        }
        return [];
    }

    //TODO if not use remove it!
    openStreetUrl(location) {
        let {lat, lng} = this.toLatLng(location);
        // const zarib = 0.0000000000001;

        // let p1 = `${+lat - zarib}%2C${+lat + zarib}`;
        // let p2 = `${+lng - zarib}%2C${+lng + zarib}`;
        let marker = `${lat}%2C${lng}`;

        // console.log(
        //     `https://www.openstreetmap.org/export/embed.html?bbox=${p1}%2C${p2}&amp;layer=mapnik&amp;marker=${marker}`
        // );

        // return `https://www.openstreetmap.org/export/embed.html?bbox=${p1}%2C${p2}&amp;layer=mapnik&amp;marker=${marker}`;
        return `https://www.openstreetmap.org/export/embed.html?bbox=-79.38736259937288%2C43.66031216247064%2C-79.38510954380035%2C43.661590893630965&amp;layer=mapnik&amp;marker${marker}`;
    }
})();

//http://www.openstreetmap.org/export/embed.html?bbox=79.84942674636841%2C6.899900944350287%2C79.85650777816772%2C6.90436374803887&amp;layers=ND

//https://www.openstreetmap.org/export/embed.html?bbox=43.64326289999999%2C-79.3792132%2C43.643342899999986%2C-79.3791332&amp;layer=mapnik&amp;marker=-79.3791732%2C43.64330289999999
//https://www.openstreetmap.org/export/embed.html?bbox=43.64326289999999%2C-79.3792132%2C43.643342899999986%2C-79.3791332&amp;layer=mapnik&amp;marker=-79.3791732%2C43.64330289999999

/*

<iframe width="425" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://www.openstreetmap.org/export/embed.html?bbox=-79.38736259937288%2C43.66031216247064%2C-79.38510954380035%2C43.661590893630965&amp;layer=mapnik" style="border: 1px solid black"></iframe><br/><small><a href="https://www.openstreetmap.org/#map=19/43.66095/-79.38624">View Larger Map</a></small>

*/
